import styled from 'styled-components';
import { OWL, CHEGG_SIHP } from '../types';
export var Bounding = styled.div.withConfig({
  componentId: "sc-1dvqfp0-0"
})(["position:relative;max-width:530px;min-width:280px;height:fit-content;text-align:center;", ""], function (_ref) {
  var site = _ref.site;
  return site === OWL ? "\n    max-width: '600px';\n    margin: 0 auto;\n  " : '';
});
export var Wrapper = styled.div.withConfig({
  componentId: "sc-1dvqfp0-1"
})(["", ""], function (_ref2) {
  var site = _ref2.site;
  if (site === OWL || site === CHEGG_SIHP) {
    return '';
  }
  return "\n      font-family: \"Aspira\", \"Helvetica\", \"Arial\", Sans-serif;\n      background-color: #FFFFFF;\n      padding: 32px 0;\n      box-shadow: rgba(0, 0, 0, 0.13) 0 0 18px;\n      height: fit-content;\n    ";
});